
























































































































































































































import {WorkTaskRuleModel, AccountTypeEnum, TenantUserModel, VisitRuleModel} from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import {visitRulesStore} from '../+state/store';
import VisitPlanDialog from '@/libs/parties/components/VisitPlanDialog.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudOrderBy } from '@/libs/core/+state/models/crud-order-by';
import ExportDialog from "@/libs/common/components-smart/ExportDialog.vue";
import { Filters, PageFilter } from '@/filters';

@Component({
    components: {
      VisitPlanDialog
    }
})
export default class VisitRules extends Page {

    pageInitialization = true;
    mobileFiltersShow = false;
    filterParty: string | null = "";
    filterTown: string | null = "";
    filterDistrict: string | null = "";
    filterUser: string | null = "";
    searchValue: string | null = "";
    pageIndex = 1;
    pageSize = 25;
    sortBy = [ "createdAt" ];
    sortDesc = [ true ];
    filterCatalogueItem: Array<string> | null = null;

    get headers() {
        return [
			{ text: "Klient", value: "party.displayName", align: "left", width: "10%" },
			{ text: this.$i18n.t("newWorkTasks.table.headers.district"), value: "party.district.name", align: "left", width: "10%" },
			{ text: this.$i18n.t("newWorkTasks.table.headers.town"), value: "party.town.name", align: "left", width: "10%" },
			{ text: this.$i18n.t("newWorkTasks.table.headers.mainCareProvider"), value: "party.mainCareProvider.lastName", align: "left", width: "10%" },
			{ text: this.$i18n.t("common.name"), value: "name", align: "left" },
			{ text: "Opakování", value: "fromTime", align: "left" },
			{ text: "Čas od", value: "fromTime", align: "left", width: "6%" },
			{ text: "Čas do", value: "toTime", align: "left", width: "6%" },
			{ text: "Zahájení", value: "startDate", align: "left", width: "7%" },
			{ text: "Ukončení", value: "endDate", align: "left", width: "7%" },
			{ text: "Poskytované úkony", value: "toTime", align: "left" },
			{ text: "", value: "", align: "right" }
        ];
    }

    get items () {
        return [...visitRulesStore.useGetter(CrudGetter.Data)];
    }

    get loading () {
        return visitRulesStore.useGetter(CrudGetter.Pending);
    }

    get totalRows (): number {
        return ({...visitRulesStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

		get exporting(): boolean {
				return visitRulesStore.useGetter(CrudGetter.Downloading);
		}

    get isAdmin (): boolean {
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        return tenantUser.accountType == AccountTypeEnum.Admin;
    }

    @Prop() tenantId!: string;

    @Ref() visitPlanDialog!: VisitPlanDialog;
    @Ref() exportDialog!: ExportDialog;

    @Watch("searchValue")
    @Watch("filterParty")
    @Watch("filterTown")
    @Watch("filterDistrict")
    @Watch("filterUser")
    @Watch("filterCatalogueItem")
    filtersChanged (v: string, p: string) {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.pageIndex = 1;
            this.loadItems();
        });
    }

    @Watch("pageIndex")
    @Watch("pageSize")
    paginationChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    @Watch("pageSize")
    pageSizeChanged () {
        this.pageIndex = 1;
    }

    @Watch("sortBy")
    @Watch("sortDesc")
    sortChanged () {
        this.saveQuery();
        if (this.pageInitialization || this.isPageLocked())
            return;
        this.pageLock(this.$nextTick()).then(() => {
            this.loadItems();
        });
    }

    created () {
        if (this.getQuery("party") != null || this.getQuery("district") != null || this.getQuery("town") != null || this.getQuery("user") != null || this.getQuery("pageSize") != null) {
            this.filterParty = this.getQuery("party") ?? "";
            this.filterDistrict = this.getQuery("district") ?? "";
            this.filterTown = this.getQuery("town") ?? "";
            this.filterUser = this.getQuery("user") ?? "";
            this.pageSize = this.getQueryInt("pageSize") ?? 25;
        }
        else {
            this.filterParty = Filters.loadFilter('VisitRules', 'party') ?? null;
            this.filterDistrict = Filters.loadFilter('VisitRules', 'district') ?? null;
            this.filterTown = Filters.loadFilter('VisitRules', 'town') ?? null;
            this.filterUser = Filters.loadFilter('VisitRules', 'user') ?? null;
            const filterCatalogueItemValue = Filters.loadFilter('VisitRules', 'catalogueItem');
            this.filterCatalogueItem = filterCatalogueItemValue ? JSON.parse(filterCatalogueItemValue) : null;
            this.pageSize = Number(Filters.loadFilter('VisitRules', 'pageSize', '25')) ?? 25;
            this.saveQuery();
        }
    }

    mounted () {
        this.loadItems();
    }

    saveQuery () {
        this.setQuery("party", this.filterParty);
        this.setQuery("district", this.filterDistrict);
        this.setQuery("town", this.filterTown);
        this.setQuery("user", this.filterUser);
        this.setQuery("pageSize", this.pageSize?.toString());
        const filters: PageFilter = {
            pageName: 'VisitRules',
            filters: [
                { name: 'party', value: this.filterParty },
                { name: 'district', value: this.filterDistrict },
                { name: 'town', value: this.filterTown },
                { name: 'user', value: this.filterUser },
                { name: 'catalogueItem', value: this.filterCatalogueItem },
                { name: 'pageSize', value: this.pageSize > 0 ? this.pageSize : 25 }
            ]
        };
        Filters.saveFilters(filters);
    }

    clearFilters () {
        this.filterParty = null;
        if (this.isAdmin) {
            this.filterDistrict = null;
        }
        this.filterTown = null;
        this.filterUser = null;
        this.searchValue = null;
        this.saveQuery();
    }

    getFilters(): CrudQueryPredicate[] {

        let filters: CrudQueryPredicate[] = [];

        if (this.searchValue)
            filters.push({ field: "name", op: "c", comparand: this.searchValue });
        
        if (this.filterParty) 
            filters.push({ field: "partyId", op: "eq", comparand: this.filterParty });
        
        if (this.filterUser) 
            filters.push({ field: "party.mainCareProviderId", op: "eq", comparand: this.filterUser });
        
        if (this.filterDistrict) 
            filters.push({ field: "party.districtId", op: "eq", comparand: this.filterDistrict });

        if (this.filterTown) 
            filters.push({ field: "party.townId", op: "eq", comparand: this.filterTown });

        if (this.filterCatalogueItem) {
            const catalogueItemFilter: Array<any> = [];
            this.filterCatalogueItem.forEach((e: string) => {
                catalogueItemFilter.push({
                    field: "visitRuleWorkTasks.workTaskRule.catalogueItemId",
                    op: "eq",
                    comparand: e,
                    junction: "or"
                });
            });
            filters.push({ field: "visitRuleWorkTasks.workTaskRule.catalogueItemId", op: "wrap", comparand: catalogueItemFilter });
        }

        return filters;

    }

		getPayload() {
				const orderBy: CrudOrderBy<VisitRuleModel>[] = [];
				if (this.sortBy.length == 0) {
					orderBy.push({
						field: "createdAt",
						index: 1,
						order: "desc"
					});
				}
				else {
					orderBy.push({
						field: this.sortBy.first(),
						index: 1,
						order: this.sortDesc.first() ? "desc" : "asc"
					});
				}
				return  createCrudQueryPayload<VisitRuleModel>(orderBy, this.getFilters(), {
					pageIndex: this.pageIndex,
					pageSize: this.pageSize
				});
		}

    loadItems () {
        visitRulesStore.dispatch(CrudAction.GetAll, this.getPayload());
        this.subscribe(visitRulesStore, CrudReponse.GetAll).then(() => {
            this.pageInitialization = false
        });
    }

    openItemClick (v: WorkTaskRuleModel) {
        this.visitPlanDialog.open(v.id!, v.partyId!);
    }

    createClick () {
        this.visitPlanDialog.open();
    }

		getWeekDays(item: VisitRuleModel) {

				const weekDays = [];

				if (item.onMonday)
					weekDays.push("Po");

				if (item.onTuesday)
					weekDays.push("Út");

				if (item.onWednesday)
					weekDays.push("St");

				if (item.onThursday)
					weekDays.push("Čt");

				if (item.onFriday)
					weekDays.push("Pá");

				if (item.onSaturday)
					weekDays.push("So");

				if (item.onSunday)
					weekDays.push("Ne");

				return weekDays.join(", ");

		}

		exportClick () {
				this.exportDialog.open();
		}

		exportDownload () {
				visitRulesStore.dispatch(CrudAction.Download, this.getPayload());
				this.subscribe(visitRulesStore, CrudReponse.Download).then(() => {
					this.exportDialog.close();
				});
		}

}
